/**
 * Created by Josef Jurca on 25.8.2017.
 */
import _ from 'lodash';
import {
    convertFromPaymentGateways,
    convertForConfigurePaymentGateway,
    convertFromConfigurePaymentGateway,
    convertForTransactionPurchase,
    convertFromTransactionPurchase,
    convertForProductPrice,
    convertFromProductPrice,
    convertForAddPaymentMethod,
    convertFromAddPaymentMethod,
    convertForCancelPayment,
    convertForAddCard,
    convertFromAddCard,
    convertForGetPaymentHistory,
    convertFromGetPaymentHistory
} from '../adapters/payment';
import {isValidResponse} from '../validators/assets';
import PaymentGateway from 'models/paymentgateway';
import PaymentHistory from 'models/paymenthistory';

/**
 * Retrieves active gateways.
 *
 * @returns {Promise} Gateways promise..
 */
function listPaymentGateways () {
    let url = this._baseUrl + this._endPoints.listPaymentGateways;

    return this.read(
        {
            url: url
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return _.map(convertFromPaymentGateways(response), (gatewayData) => {
                return new PaymentGateway(gatewayData);
            });
        });
}

/**
 * Sends configuration to Kaltura and retrieves redirect URL.
 *
 * @param {Object} gateway - Default gateway.
 * @param {string} userId - Users ID.
 * @param {Object} order - Order.
 * @returns {Promise} Promise.
 */
function configurePaymentGateway (gateway, userId, order) {
    let url = this._baseUrl + this._endPoints.invokePaymentGateways,
        data = convertForConfigurePaymentGateway(gateway, userId, order);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return convertFromConfigurePaymentGateway(response);
        });
}

/**
 * Sends configuration to Kaltura and retrieves redirect URL.
 *
 * @param {Object} paymentMethodParams - Payment method params.
 * @returns {Promise} Promise.
 */
function addPaymentMethod (paymentMethodParams) {
    let url = this._baseUrl + this._endPoints.invokePaymentGateways,
        data = convertForAddPaymentMethod(paymentMethodParams);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return convertFromAddPaymentMethod(response);
        });
}


/**
 * Sends configuration to Kaltura and retrieves redirect URL.
 *
 * @param {Object} addCardParams - Add card params.
 * @returns {Promise} Promise.
 */
function addCard (addCardParams) {

    let url = this._baseUrl + this._endPoints.invokePaymentGateways,
        data = convertForAddCard(addCardParams);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return convertFromAddCard(response);
        });
}

/**
 * Sends success Yaad redirect data back to Kaltura.
 *
 * @param {Object} redirectData - Data from redirect URL.
 * @returns {Promise} Promise.
 */
function transactionPurchase (redirectData) {
    let url = this._baseUrl + this._endPoints.transactionPurchase,
        data = convertForTransactionPurchase(redirectData);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromTransactionPurchase(response);
        });
}

/**
 * Listing products and prices.
 *
 * @param {string} subscriptionId - Subscription ID.
 * @returns {Promise} Promise.
 */
function productPriceList (subscriptionId) {
    let url = this._baseUrl + this._endPoints.productPrice,
        data = convertForProductPrice(subscriptionId);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return convertFromProductPrice(response);
        });
}

/**
 * Cancel payment.
 *
 * @param {Object} paymentParams - Payment params..
 * @returns {Promise} Promise.
 */
function cancelPayment (paymentParams) {
    let url = this._baseUrl + this._endPoints.invokePaymentGateways,
        data = convertForCancelPayment(paymentParams);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        });
}

/**
 * Get payment history.
 *
 * @param {Object} paymenthistoryParams - Payment history params..
 * @returns {Promise} Promise.
 */
function getPaymentHistory (paymenthistoryParams) {
    let url = this._baseUrl + this._endPoints.invokePaymentGateways,
        data = convertForGetPaymentHistory(paymenthistoryParams);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return convertFromGetPaymentHistory(response.result).map((historyItem) => {

                 return new PaymentHistory(historyItem);
            });
        });
}

export {
    listPaymentGateways,
    configurePaymentGateway,
    transactionPurchase,
    productPriceList,
    addPaymentMethod,
    addCard,
    cancelPayment,
    getPaymentHistory
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/payment.js